import Box from "react-raster";
import React from "react";
import styled from "styled-components";

import ButtonLink from "../ButtonLink";
import Container from "../Container";
import { H2, Copy, Eyebrow } from "../Typography";
import HorizontalCard from "./HorizontalCard";
import HorizontalCollapsible from "./HorizontalCollapsible";

const FullWidthWrapper = styled.div`
  background-color: ${({ theme, $backgroundColour }) =>
    theme.colours[$backgroundColour]};
  width: 100%;
  padding-bottom: ${({ $hasBottomMargin }) =>
    $hasBottomMargin ? "60px" : "20px"};
  padding-top: ${({ $hasTopMargin }) => ($hasTopMargin ? "60px" : "20px")};
`;

const ImageWrapper = styled.div`
  margin-bottom: 80px;
  img {
    max-width: 100%;
  }
`;

const LinkWrapper = styled.div`
  color: ${({ theme }) => theme.colours.grey};
  display: flex;
  align-items: center;
  width: max-content;
`;

function Horizontal({
  description,
  descriptionColour,
  cards = [],
  mainTitle,
  titleColour,
  backgroundColour,
  hasTopMargin,
  hasBottomMargin,
  hideTitle,
  hideIndexNumberDisplay,
  mobileImage,
  numberOfColumns,
  eyebrow,
  layout,
  ctaProps,
}) {
  const { ctaLabel, ctaUrl } = ctaProps || {};
  return (
    <FullWidthWrapper
      $backgroundColour={backgroundColour}
      $hasBottomMargin={hasBottomMargin}
      $hasTopMargin={hasTopMargin}
    >
      <Container>
        {eyebrow && (
          <Box cols={[6, 12]}>
            <Eyebrow colour={titleColour || "grey"} marginBottom="0px">
              {eyebrow}
            </Eyebrow>
          </Box>
        )}
        <Box cols={[6, 12]}>
          {!hideTitle && mainTitle && (
            <H2 $colour={titleColour}>{mainTitle}</H2>
          )}
          {description && <Copy colour={descriptionColour}>{description}</Copy>}
          {mobileImage && (
            <ImageWrapper>
              <img
                src={mobileImage?.file?.url}
                alt={mobileImage?.description || "image"}
              />
            </ImageWrapper>
          )}
        </Box>
        <Box cols={[6, 12]}>
          {cards?.map((card, i) => (
            <>
              {layout === "horizontal collapsible" ? (
                <Box key={card.id} rowspan={1} marginBottom={["30px", 0]}>
                  <HorizontalCollapsible
                    number={i + 1}
                    hideIndexNumberDisplay={hideIndexNumberDisplay}
                    eyebrow={i < 10 ? `0${i + 1}` : i}
                    {...card}
                  />
                </Box>
              ) : (
                <Box
                  key={card.id}
                  colspan={[6, 12 / (numberOfColumns || 1)]}
                  marginBottom={["30px", 0]}
                >
                  <HorizontalCard
                    number={i + 1}
                    hideIndexNumberDisplay={hideIndexNumberDisplay}
                    {...card}
                  />
                </Box>
              )}
            </>
          ))}
        </Box>
        {ctaUrl && (
          <LinkWrapper>
            <ButtonLink
              isWhite={
                !!(
                  !backgroundColour ||
                  backgroundColour === "default" ||
                  backgroundColour === "white" ||
                  backgroundColour === "alabasterWhite"
                )
              }
              label={ctaLabel}
              url={ctaUrl}
            />
          </LinkWrapper>
        )}
      </Container>
    </FullWidthWrapper>
  );
}

export default Horizontal;
